import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
const AI_HIGHLIGHT_DURATION_MS = 2000;

/**
 * Hook to show a brief highlight animation when a node is updated by AI.
 * Detects changes to a `_refreshKey` prop, skipping the initial mount.
 *
 * @param refreshKey - A key that changes each time the AI updates the node
 * @returns Whether the highlight should currently be visible
 */
export function useAIHighlight(refreshKey) {
  const $ = _c(3);
  const [showHighlight, setShowHighlight] = useState(false);
  const prevKeyRef = useRef(undefined);
  const hasInitializedRef = useRef(false);
  let t0;
  let t1;
  if ($[0] !== refreshKey) {
    t0 = () => {
      if (!refreshKey) {
        return;
      }
      if (!hasInitializedRef.current) {
        hasInitializedRef.current = true;
        prevKeyRef.current = refreshKey;
        return;
      }
      if (refreshKey !== prevKeyRef.current) {
        setShowHighlight(true);
        prevKeyRef.current = refreshKey;
        const timer = setTimeout(() => {
          setShowHighlight(false);
        }, AI_HIGHLIGHT_DURATION_MS);
        return () => clearTimeout(timer);
      }
    };
    t1 = [refreshKey];
    $[0] = refreshKey;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return showHighlight;
}